import React from "react";
import { RequireStaff } from "@/components/RequireStaff";
import { useStaffDeals } from "@/hooks/useStaffDeals";
import { StaffKpiCards } from "@/components/staff/StaffKpiCards";
import { StaffPipelineChart } from "@/components/staff/StaffPipelineChart";
import { Button } from "@/components/ui/button";
import { RefreshCw, GitBranch } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const translations = {
  en: {
    title: "Pipeline by Status",
    subtitle: "Overview of deal progression across all stages",
    refresh: "Refresh",
    loading: "Loading pipeline..."
  },
  fr: {
    title: "Pipeline par Statut",
    subtitle: "Vue d'ensemble de la progression des dossiers à travers toutes les étapes",
    refresh: "Actualiser",
    loading: "Chargement du pipeline..."
  }
};

export default function StaffPipeline() {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  
  const { loading, kpis, pipelineStats, refetch } = useStaffDeals('pipeline');

  return (
    <RequireStaff>
      <div className="space-y-6 font-['Geist',sans-serif]">
        <header className="flex flex-col md:flex-row md:items-end justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-purple-500/20 rounded-lg">
              <GitBranch className="w-6 h-6 text-purple-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">{t.title}</h1>
              <p className="text-gray-400">{t.subtitle}</p>
            </div>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => refetch?.()}
            className="border-gray-700 text-gray-300 hover:bg-gray-800"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            {t.refresh}
          </Button>
        </header>

        <StaffKpiCards kpis={kpis} view="pipeline" />

        {loading ? (
          <div className="bg-gray-800/50 rounded-xl p-8 text-center">
            <p className="text-gray-400 animate-pulse">{t.loading}</p>
          </div>
        ) : (
          <StaffPipelineChart data={pipelineStats} />
        )}
      </div>
    </RequireStaff>
  );
}
